import React, { useEffect, useState } from "react";

import { createPortal } from "react-dom";

import "../css/Header.css";



import {

  Link,

  useLocation,

  useNavigate,

} from "react-router-dom";



import logo from "../images/NavBar.png";



export default function Header() {

  const [isLoggedIn, setIsLoggedIn] =

    useState(false);



  const [menuOpen, setMenuOpen] =

    useState(false);



  const [isScrolled, setIsScrolled] =

    useState(false);



  const navigate = useNavigate();

  const location = useLocation();



  /* ======================================================

     AUTH STATE

  ====================================================== */



  useEffect(() => {

    const token =

      localStorage.getItem("jwtToken");



    setIsLoggedIn(Boolean(token));



    // Close menu whenever route changes

    setMenuOpen(false);

  }, [location.pathname]);



  /* ======================================================

     PAGE SCROLL EFFECT

  ====================================================== */



  useEffect(() => {

    const handleScroll = () => {

      setIsScrolled(window.scrollY > 15);

    };



    handleScroll();



    window.addEventListener(

      "scroll",

      handleScroll,

      { passive: true }

    );



    return () => {

      window.removeEventListener(

        "scroll",

        handleScroll

      );

    };

  }, []);



  /* ======================================================

     ESCAPE KEY

  ====================================================== */



  useEffect(() => {

    const handleEscape = (event) => {

      if (event.key === "Escape") {

        setMenuOpen(false);

      }

    };



    window.addEventListener(

      "keydown",

      handleEscape

    );



    return () => {

      window.removeEventListener(

        "keydown",

        handleEscape

      );

    };

  }, []);



  /* ======================================================

     MOBILE DRAWER SCROLL LOCK

  ====================================================== */



  useEffect(() => {

    if (!menuOpen) {

      return undefined;

    }



    const previousOverflow =

      document.body.style.overflow;



    document.body.style.overflow = "hidden";



    return () => {

      document.body.style.overflow =

        previousOverflow;

    };

  }, [menuOpen]);



  /* ======================================================

     LOGOUT

  ====================================================== */



  const handleLogout = () => {

    localStorage.removeItem("jwtToken");



    setIsLoggedIn(false);

    setMenuOpen(false);



    navigate("/");

  };



  /* ======================================================

     ACTIVE ROUTE

  ====================================================== */



  const isActive = (path) => {

    if (path === "/") {

      return location.pathname === "/";

    }



    return location.pathname.startsWith(path);

  };



  const getNavClass = (path) =>

    `ms-nav-link ${

      isActive(path) ? "active" : ""

    }`;



  return (

    <header

      className={`ms-header ${

        isScrolled ? "scrolled" : ""

      }`}

    >

      {/* ==================================================

          DESKTOP / MAIN HEADER

      ================================================== */}



      <div className="ms-header-container">

        {/* BRAND */}

        <Link

          to="/"

          className="ms-brand"

          aria-label="MindSpark Home"

          onClick={() => setMenuOpen(false)}

        >

          <div className="ms-brand-logo-wrap">

            <img

              src={logo}

              alt="MindSpark EduTech"

              className="ms-logo"

            />

          </div>



          {/* <div className="ms-brand-text">

            <span className="ms-brand-tagline">

              Learning Through Technology

            </span>

          </div> */}

        </Link>



        {/* =================================================

            DESKTOP NAVIGATION

        ================================================= */}



        <nav

          className="ms-desktop-nav"

          aria-label="Main navigation"

        >

          <Link

            to="/"

            className={getNavClass("/")}

          >

            <span>Home</span>

          </Link>



          {!isLoggedIn && (

            <Link

              to="/temp-school"

              className={getNavClass(

                "/temp-school"

              )}

            >

              <span>Our Network</span>

            </Link>

          )}

          <Link
            to="/project-kits"
            className={getNavClass(
              "/project-kits"
            )}
          >
            <span>Project Kits</span>
          </Link>



          <Link

            to="/about-us"

            className={getNavClass(

              "/about-us"

            )}

          >

            <span>About Us</span>

          </Link>



          <Link

            to="/careers"

            className={getNavClass(

              "/careers"

            )}

          >

            <span>Careers</span>

          </Link>



          {isLoggedIn && (

            <button

              type="button"

              className="ms-nav-link ms-logout-link"

              onClick={handleLogout}

            >

              <span>Logout</span>

            </button>

          )}

        </nav>



        {/* =================================================

            DESKTOP ACTIONS

        ================================================= */}



        <div className="ms-header-actions">

          {/* PARTNER */}

          <a

            href="https://forms.gle/MgUEEdZtwJtLwTjY8"

            target="_blank"

            rel="noopener noreferrer"

            className="ms-partner-btn"

          >

            <span className="ms-action-icon ms-partner-icon">

              <svg

                viewBox="0 0 24 24"

                aria-hidden="true"

              >

                <path

                  d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3ZM8 11c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3Zm0 2c-2.33 0-7 1.17-7 3.5V19h10v-2.5c0-.84.33-1.55.87-2.15C10.6 13.48 9.13 13 8 13Zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5Z"

                  fill="currentColor"

                />

              </svg>

            </span>



            <span>

              Partner With Us

            </span>

          </a>



          {/* DOWNLOAD */}

          <a

            href="/apk/app-release.apk"

            download

            className="ms-download-btn"

          >

            <span className="ms-action-icon">

              <svg

                viewBox="0 0 24 24"

                aria-hidden="true"

              >

                <path

                  d="M17 18H7V6h5V4H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-5h-2v5ZM13 4v7.17l-2.59-2.58L9 10l5 5 5-5-1.41-1.41L15 11.17V4h-2Z"

                  fill="currentColor"

                />

              </svg>

            </span>



            <span>

              Download App

            </span>



            <span

              className="ms-download-arrow"

              aria-hidden="true"

            >

              →

            </span>

          </a>

        </div>



        {/* =================================================

            MOBILE BUTTON

        ================================================= */}



        <button

          type="button"

          className={`ms-menu-button ${

            menuOpen ? "active" : ""

          }`}

          aria-label={

            menuOpen

              ? "Close menu"

              : "Open menu"

          }

          aria-expanded={menuOpen}

          aria-controls="mindspark-mobile-menu"

          onClick={() =>

            setMenuOpen((prev) => !prev)

          }

        >

          <span />

          <span />

          <span />

        </button>

      </div>



      {/* ==================================================

          MOBILE MENU

      ================================================== */}



      {createPortal(

        <>

      <button

        type="button"

        className={`ms-mobile-menu-overlay ${

          menuOpen ? "open" : ""

        }`}

        aria-label="Close menu"

        aria-hidden={!menuOpen}

        tabIndex={menuOpen ? 0 : -1}

        onClick={() => setMenuOpen(false)}

      />



      <div

        id="mindspark-mobile-menu"

        className={`ms-mobile-menu ms-mobile-menu-drawer ${

          menuOpen ? "open" : ""

        }`}

        role="dialog"

        aria-modal="true"

        aria-label="Mobile navigation menu"

        aria-hidden={!menuOpen}

      >

        <div className="ms-mobile-menu-inner">

          <button

            type="button"

            className="ms-mobile-menu-close"

            aria-label="Close menu"

            onClick={() => setMenuOpen(false)}

          >

            <span />

            <span />

          </button>



          {/* MOBILE TOP MESSAGE */}

          <div className="ms-mobile-brand-message">

            <span className="ms-mobile-brand-icon">

              ✦

            </span>



            <div>

              <strong>

                MindSpark EduTech

              </strong>



              <span>

                Learning Through Technology

              </span>

            </div>

          </div>



          {/* NAVIGATION */}

          <nav

            aria-label="Mobile navigation"

            className="ms-mobile-navigation"

          >

            <Link

              to="/"

              className={getNavClass("/")}

              onClick={() =>

                setMenuOpen(false)

              }

            >

              <div className="ms-mobile-link-left">

                <span className="ms-nav-number">

                  01

                </span>



                <span>Home</span>

              </div>



              <span className="ms-mobile-arrow">

                →

              </span>

            </Link>



            {!isLoggedIn && (

              <Link

                to="/temp-school"

                className={getNavClass(

                  "/temp-school"

                )}

                onClick={() =>

                  setMenuOpen(false)

                }

              >

                <div className="ms-mobile-link-left">

                  <span className="ms-nav-number">

                    02

                  </span>



                  <span>

                    Our Network

                  </span>

                </div>



                <span className="ms-mobile-arrow">

                  →

                </span>

              </Link>

            )}

          <Link
            to="/project-kits"
            className={getNavClass(
              "/project-kits"
            )}
            onClick={() =>
              setMenuOpen(false)
            }
          >
            <div className="ms-mobile-link-left">
              <span className="ms-nav-number">
                {!isLoggedIn ? "03" : "02"}
              </span>

              <span>Project Kits</span>
            </div>

            <span className="ms-mobile-arrow">
              →
            </span>
          </Link>



            <Link

              to="/about-us"

              className={getNavClass(

                "/about-us"

              )}

              onClick={() =>

                setMenuOpen(false)

              }

            >

              <div className="ms-mobile-link-left">

                <span className="ms-nav-number">

                  {!isLoggedIn ? "04" : "03"}

                </span>



                <span>About Us</span>

              </div>



              <span className="ms-mobile-arrow">

                →

              </span>

            </Link>



            <Link

              to="/careers"

              className={getNavClass(

                "/careers"

              )}

              onClick={() =>

                setMenuOpen(false)

              }

            >

              <div className="ms-mobile-link-left">

                <span className="ms-nav-number">

                  {!isLoggedIn ? "05" : "04"}

                </span>



                <span>Careers</span>

              </div>



              <span className="ms-mobile-arrow">

                →

              </span>

            </Link>



            {isLoggedIn && (

              <button

                type="button"

                className="ms-nav-link ms-mobile-logout"

                onClick={handleLogout}

              >

                <div className="ms-mobile-link-left">

                  <span className="ms-nav-number">

                    05

                  </span>



                  <span>Logout</span>

                </div>



                <span className="ms-mobile-arrow">

                  →

                </span>

              </button>

            )}

          </nav>



          {/* =================================================

              MOBILE ACTIONS

          ================================================= */}



          <div className="ms-mobile-actions">

            <a

              href="https://forms.gle/MgUEEdZtwJtLwTjY8"

              target="_blank"

              rel="noopener noreferrer"

              className="ms-partner-btn"

              onClick={() =>

                setMenuOpen(false)

              }

            >

              <span className="ms-action-icon">

                <svg

                  viewBox="0 0 24 24"

                  aria-hidden="true"

                >

                  <path

                    d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3ZM8 11c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3Zm0 2c-2.33 0-7 1.17-7 3.5V19h10v-2.5c0-.84.33-1.55.87-2.15C10.6 13.48 9.13 13 8 13Zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5Z"

                    fill="currentColor"

                  />

                </svg>

              </span>



              Partner With Us

            </a>



            <a

              href="/apk/app-release.apk"

              download

              className="ms-download-btn"

              onClick={() =>

                setMenuOpen(false)

              }

            >

              <span className="ms-action-icon">

                <svg

                  viewBox="0 0 24 24"

                  aria-hidden="true"

                >

                  <path

                    d="M17 18H7V6h5V4H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-5h-2v5ZM13 4v7.17l-2.59-2.58L9 10l5 5 5-5-1.41-1.41L15 11.17V4h-2Z"

                    fill="currentColor"

                  />

                </svg>

              </span>



              Download App



              <span className="ms-download-arrow">

                →

              </span>

            </a>

          </div>



          {/* MOBILE PROGRAM TAGS */}

          <div className="ms-mobile-programs">

            <span className="yellow">

              Robotics

            </span>



            <span className="purple">

              AI

            </span>



            <span className="blue">

              Coding

            </span>



            <span className="teal">

              STEM

            </span>

          </div>

        </div>

      </div>

        </>,

        document.body

      )}



      {/* COLOR LINE */}

      <div className="ms-header-accent">

        <span />

      </div>

    </header>

  );

}
